module.exports = __webpack_public_path__ + "img/k1_float_ico_half.05a473cf.png";